import { Component, OnInit } from '@angular/core';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { RoleGuard } from '../../../guards/role.guard';
import { NavigationItem, NAVIGATION_ITEMS } from '../../../interfaces/role-permissions.interface';

@Component({
  selector: 'app-sidebar',
  imports: [
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    RouterModule
],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss'
})
export class SidebarComponent implements OnInit {
  
  visibleNavigationItems: NavigationItem[] = [];

  constructor(private roleGuard: RoleGuard) {}

  ngOnInit() {
    this.loadVisibleNavigationItems();
  }

  /**
   * Betölti a felhasználó számára elérhető navigációs elemeket
   */
  private loadVisibleNavigationItems() {
    this.visibleNavigationItems = NAVIGATION_ITEMS.filter(item => 
      this.roleGuard.checkPermission(item.requiredPermission)
    );
  }

  /**
   * Ellenőrzi, hogy van-e jogosultság egy adott oldalhoz
   */
  hasPermission(permission: string): boolean {
    return this.roleGuard.checkPermission(permission);
  }
}
